const orderPlanPeriodTimes = [
    {
        value: 'day',
        label: 'Günde bir tekrar.'
    },
    {
        value: 'week',
        label: 'Haftada bir tekrar.'
    },
    {
        value: 'month',
        label: 'Ayda bir tekrar.'
    },
    {
        value: 'Year',
        label: 'Yılda bir tekrar.'
    },
]

export default orderPlanPeriodTimes